import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ActiveInactiveFor, FileUploadFor, KeyValues10, LocalService, NumericConfig, Status } from 'src/service/local.service';
import { PrinterService } from 'src/service/printer.service';
import { SellerManagementService } from 'src/service/seller-management.service';

@Component({
  selector: 'app-receipt-icon-config',
  templateUrl: './receipt-icon-config.component.html',
  styleUrl: './receipt-icon-config.component.scss'
})
export class ReceiptIconConfigComponent {
  @ViewChild('receipt_icon_setting_config')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() businessId: string = '';
  data: KeyValues10[]; searchLanguage: string = '';
  selectedLanguageId: string = ''; FileUploadFor = FileUploadFor;

  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig;

  elementIds: any = {
    save: "btn_receipt_icon_config_save",
    fontName: 'txt_receipt_icon_config_font_name',
    lineHeight: 'txt_receipt_icon_config_line_height',
    itemsLineHeight: 'txt_receipt_icon_config_items_line_height',
    fontSize: 'txt_receipt_icon_config_font_size',
    search: 'txt_receipt_icon_config_search',
    fileUpload: 'txt_receipt_icon_config_file_upload',
    height: 'txt_height',
    width: 'txt_width',
  };

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private printerService: PrinterService, private sellerManagementService: SellerManagementService) {
  }

  ngOnInit(): void {
    this.onInitiate();
  }

  onInitiate() {

  }


  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    if (this.businessId && this.businessId.length > 5) {
      this.printerService.getPrintReceiptIconsByBusinessId(this.businessId).subscribe(result => {
        this.data = result;
        this.onFillFontTitle();
      });
    }
  }

  onAction(index: number, key: string = '') {
    switch (index) {
      case 1: {
        if (key && key.length > 0) {
          const item = this.data.find(x => x.key == key);
          if (item && item.v7 && item.v7.toString().length > 0 && item.v8 && item.v8.toString().length > 0) {
            this.sellerManagementService.savePrintIconDimensions(item.key, parseFloat(item.v7.toString()), parseFloat(item.v8.toString())).subscribe(result => {
              this.localService.showInformationByStatus(result.status);
            });
          }
        }
      } break;
    }
  }

  onFillFontTitle() {
    this.data?.forEach(fontNameOption => {
      const title = this.localService.getEquivalentTitle(fontNameOption.v1);
      fontNameOption.v4 = title;
      fontNameOption.v5 = title + ';' + title.toLowerCase();
    });
    if (this.data) {
      this.data = this.localService.Sort(this.data, true, "v4");
    }
  }

  onActiveInactiveStatus(key: string) {
    this.printerService.activeInactiveStatus({} as any, key, ActiveInactiveFor.ReceiptIcon).subscribe(result => {
      if (result && result.status == Status.Success) {
        const updatedItem = this.data.find(x => x.key == key);
        updatedItem.v2 = updatedItem.v2 == "1" ? "0" : "1";
      }
      if (result && result.status) {
        this.localService.showInformationByStatus(result.status);
      }
    });
  }

  saveBase64AsImage(base64: string, filename: string) {
    const mimeType = base64.match(/^data:(.*?);base64/)?.[1] || 'image/png';
    const blob = this.base64ToBlob(base64, mimeType);
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'receipt_icon_' + filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    URL.revokeObjectURL(url);
  }

  base64ToBlob(base64: string, mimeType: string) {
    const byteCharacters = atob(base64.split(',')[1]); // Remove Data URI scheme
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
  }
}
